import { AXDialogService } from '@acorex/components/dialog';
import { AfterViewInit, ChangeDetectorRef, Component, ViewChild, ViewEncapsulation, inject } from '@angular/core';

import { AXFormComponent } from '@acorex/components/form';
import { AXBasePageComponent } from '@acorex/components/page';
import { AXPopupService } from '@acorex/components/popup';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PublicRegisterComponent } from '@travel/public-register';
import { CaptchaOutputModel, SettingDataOutputModel } from '@travel/shared';
import { DataConfig } from '@travel/shared/services';
import { PublicLoginService } from './public-login.service';

import { AXButtonModule } from '@acorex/components/button';
import { AXDecoratorModule } from '@acorex/components/decorators';
import { AXDropdownModule } from '@acorex/components/dropdown';
import { AXFormModule } from '@acorex/components/form';
import { AXLabelModule } from '@acorex/components/label';
import { AXLoadingModule } from '@acorex/components/loading';
import { AXPasswordBoxModule } from '@acorex/components/password-box';
import { AXTextBoxModule } from '@acorex/components/text-box';
import { AXTranslationModule, AXTranslationService } from '@acorex/core/translation';
import { FormsModule } from '@angular/forms';

const AcorexModules: any[] = [
  FormsModule,
  AXButtonModule,
  AXDropdownModule,
  AXDecoratorModule,
  AXTextBoxModule,
  AXFormModule,
  AXLabelModule,
  AXPasswordBoxModule,
  AXLoadingModule,
  AXTranslationModule,
];

@Component({
  selector: 'travel-btc-workspace-public-login',
  standalone: true,
  imports: [CommonModule, ...AcorexModules],
  templateUrl: './public-login.component.html',
  styleUrl: './public-login.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class PublicLoginComponent extends AXBasePageComponent implements AfterViewInit {
  protected translateService = inject(AXTranslationService);
  _captchaCodeObject: CaptchaOutputModel = {};
  _captchLoading = false;

  _loginObj: any = {};

  @ViewChild('loginForm') loginForm!: AXFormComponent;
  settingData: SettingDataOutputModel = DataConfig.get('globalSetting');

  _changeDetectorRef = inject(ChangeDetectorRef);

  constructor(
    private _publicLoginService: PublicLoginService,
    private _dialogService: AXDialogService,
    private _popupService: AXPopupService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.getCaptchaGenerate();
  }

  getCaptchaGenerate() {
    if (!this.isLoading) {
      this.isLoading = true;
    }
    this._publicLoginService
      .captchaGenerate()
      .then((res) => {
        this._captchaCodeObject = res;
      })
      .finally(() => {
        this.isLoading = false;
        this._changeDetectorRef.markForCheck();
      });
  }

  handleLoginClick() {
    this.loginForm.validate().then((form) => {
      if (form.result) {
        const params: any = {
          username: this._loginObj.username,
          password: this._loginObj.password,
          captchaCode: this._loginObj.captchaCode,
          captchaId: this._captchaCodeObject.id,
        };

        if (!this.isLoading) {
          this.isLoading = true;
        }

        this._publicLoginService
          .staticLogin(params)
          .then((res: any) => {
            if (res) {
              this.close(true);
              this.handleBackUrl();
            }
          })
          .catch((error: any) => {
            this.getCaptchaGenerate();
            switch (error.error.error) {
              case 'invalid_captcha':
                // توجه
                this._dialogService.alert(this.translateService.translateSync('common.attention'), error.error.error_description, 'danger');
                break;
              case 'invalid_grant':
                // نام کاربری با رمز عبور مطابقت ندارد
                this._dialogService.alert(this.translateService.translateSync('common.attention'), this.translateService.translateSync('profile.userPassFail'), 'danger');
                break;
              default:
                this._dialogService.alert(this.translateService.translateSync('common.attention'), error.error.error_description, 'danger');
                break;
            }
          })
          .finally(() => (this.isLoading = false));
      } else {
        console.log('error');
      }
    });
  }

  registerPopup(_forgotPasswordFlag: number) {
    this.close(false);
    this._popupService
      .open(PublicRegisterComponent, {
        // title: 'ثبت نام',
        title: this.translateService.translateSync('profile.register'),
        size: 'sm',
        data: {
          forgotPasswordFlag: _forgotPasswordFlag,
        },
      })
      .then((isLogin) => {
        if (isLogin) {
          this.handleBackUrl();
        }
      });
  }

  handleBackUrl() {
    this._activatedRoute.queryParams.subscribe((queryParams: any) => {
      this._router.navigate([queryParams.backUrl]);
      document.location.reload();
    });
  }
}
